import React, { useState, useEffect, useRef } from "react";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { Paper, Popover, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { Link, useNavigate } from "react-router-dom";

import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import AdmitCardPdf from "../ViewAdmitCard";
import { useReactToPrint } from "react-to-print";

function AdmitCardListing() {
  const classes = useStyles();
  const contentRef = useRef();

  const style = [
    {
      height: 'maxh67',
      style: "viewtable",
    },
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();

  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [allocatedCenters, setAllocatedCenters] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
const [selectedRowData, setSelectedRowData] = React.useState(null); 

  const navigate = useNavigate();

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleButtonClick = (type, rowId) => {
    if (type === "editCenter") {
      navigate(`/admin/editallocatedcenter/${rowId}`);
    }
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_candidate/generate/hallticket`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      console.log("response center", response)
      setAllocatedCenters(response?.data?.candidate_generate_hallticket);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Function to delete a book
  const deleteDataOfRow = async (rowId) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/registration_allocated/centers/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );

      fetchData();
      handleClose();
      toast.success("Allocation center deleted successfully");
      const updateddatatata = allocatedCenters.filter((data) => data.id !== rowId);
      setAllocatedCenters(updateddatatata);
    } catch (error) {
      toast.error("Allocation center is not deleted");
      console.error("Error deleting data: ", error);
    }
  };

  const componentRef = React.useRef(null);
  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
    // document.getElementById("elementId").classList.remove("hide-print");
  }, []);
  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
    // document.getElementById("elementId").classList.add("hide-print");
    return Promise.resolve();
  }, []);

  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "AwesomeFileName",
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });

  // const handleDownload = useReactToPrint({
  //   content: () => contentRef.current,
  //   documentTitle: "Admit Card",
  // });

  const rows = allocatedCenters.map((d) => ({
    id: d.id ? d.id : "N/A",
    full_name: d?.candidate_details?.full_name ? d?.candidate_details?.full_name : "N/A",
    email: d?.candidate_details?.email ? d?.candidate_details?.email : "N/A",
    dob: d?.candidate_details?.dob ? d?.candidate_details?.dob : "N/A",
    phone: d?.candidate_details?.phone ? d?.candidate_details?.phone : "N/A",
    gender: d?.candidate_details?.gender ? d?.candidate_details?.gender : "N/A",
    marital_status: d?.candidate_details?.marital_status ? d?.candidate_details?.marital_status : "N/A",
    category_type: d?.candidate_details?.category_type ? d?.candidate_details?.category_type : "N/A",
    active_status: d.active_status ? d.active_status : "N/A",
     rawData: d,
  }));

  const filteredRows = rows
    .filter((d) => {
      const isSearchMatch = d?.full_name
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) || d?.full_name
          .toLowerCase()
          // .includes(searchQuery.toLowerCase()) || d.batch_name
          // .toLowerCase()
          .includes(searchQuery.toLowerCase())

      return isSearchMatch;
    })
    .map((row, index) => ({
      ...row,
      srno: index + 1,
    }));


  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },

    {
      field: "full_name",
      headerName: "Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
       {
      field: "dob",
      headerName: "Date of Birth",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "email",
      headerName: "Email",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
 
    {
      field: "phone",
      headerName: "Mobile Number",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "gender",
      headerName: "Gender",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "marital_status",
      headerName: "Marital Status",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "category_type",
      headerName: "Categury type",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "active_status",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 200,
      autoPageSize: false,
      renderCell: (cellValues) => {
        return (
          <div
            className={`${classes.dflex} ${classes.w100} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
          >
           {/* <IconButton
              className={`${classes.w15}`}
              aria-describedby={id}
              onClick={(event) => {
                handleClick(event, cellValues.row.id);
              }}
            >
              <ArrowLeftIcon fontSize="small" />
            </IconButton>
            <Typography
              className={`${classes.dflex} ${classes.alignitemscenter} ${classes.texttransformcapitalize}`}
              variant="h6"
            >
              {isActive ? (
                <ActiveIcon className={`${classes.mr0_5}`} />
              ) : (
                <InactiveIcon fontSize="small" className={`${classes.mr0_5}`} />
              )}

              {cellValues.row.active_status}
            </Typography>
            <Popover
              id={id}
              open={popoveropen && selectedRowId === cellValues.row.id}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <Paper>
                <IconButton
                id="elementId"
          onClick={printFn}
          title="Print Results"
          size="large"
          // style={{ position: "fixed", right: 40, top: 30, zIndex: 1000 }}
          className={[classes.pdfBtn]}
                  // onClick={(event) => {
                  //   // handleDownload(
                  //   //   cellValues.row.id,
                  //   // );
                  //   // handleDownload();
                  //   //  handleClose();
                  //   setSelectedId(cellValues.row.id);
                  //   setTimeout(() => {
                  //     printFn();
                  //     handleDownload();
                  //   }, 100); // Give enough time to render
                  //   handleClose();
                  // }}
                >
                  <LightTooltip title="Download">
                    <CloudDownloadOutlinedIcon />
                  </LightTooltip>
                </IconButton>
             
                <IconButton>
                  <LightTooltip title="Delete">
                    <DeleteIcon
                      onClick={() => {
                        deleteDataOfRow(cellValues.row.id)
                        handleClose();
                      }}
                    />
                  </LightTooltip>
                </IconButton>
              </Paper>
            </Popover> */}
             <IconButton
                id="elementId"
          onClick={() => {
    setSelectedRowData(cellValues.row.rawData); 
    printFn();
  }}
          title="Print Results"
          size="large"
          className={[classes.pdfBtn]}
                >
                  <LightTooltip title="Download">
                    <CloudDownloadOutlinedIcon />
                  </LightTooltip>
                </IconButton>
          </div>
        );
      },
    },
  ];

  const Heading = [
    {
      id: 1,
      // inputlable: "Subject / Course",
      inputplaceholder: "Search by center",
      // export: "yes",
    },
  ];
  return (
    <>
      <ToastContainer />
      <div
    
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}  ${classes.mt1}`}
      >
        <TableViewSearch Heading={Heading} onSearch={handleSearch} />
        <TableView columns={columns} rows={filteredRows} Heading={style} />
      </div>
      <div style={{ display: "none" }}>
        <AdmitCardPdf    ref={componentRef}
       id="pdf-container" cardData={selectedRowData}/>
      </div>

    </>
  );
}
export default AdmitCardListing;
